/**
 * Feature gating helper for VIKINGOS GYM.
 * Mirrors the pattern used by AMARELO/BERROS feature gating.
 *
 * Group payment categories (categorías que cubren a N personas, ej. 2x1)
 * are exclusive to VIKINGOS GYM.
 */
export const isVikingosGym = (gymName?: string | null): boolean => {
  if (!gymName) return false;
  return gymName.toUpperCase().includes("VIKINGOS");
};

export const supportsGroupCategories = (gymName?: string | null): boolean =>
  isVikingosGym(gymName);
